import type {SanitizedHTML} from './safe-html-string'

/**
 * Assigns sanitized HTML to an element's `innerHTML`.
 *
 * `Element.innerHTML` is typed as `string` by the DOM lib, but accepts a
 * `TrustedHTML` object at runtime under enforced Trusted Types; the cast bridges
 * that gap. Pass the `SanitizedHTML` value directly — calling `.toString()` on it
 * first yields a plain string, which throws at the sink under enforced Trusted Types.
 */
export function setSanitizedInnerHTML(element: Element, html: SanitizedHTML): void {
  // eslint-disable-next-line @github-ui/github-monorepo/require-set-sanitized-inner-html -- this is the audited helper the rule steers callers toward; the value is a SanitizedHTML
  element.innerHTML = html as unknown as string
}
